<template>
  <div v-show="isShow" :style="domStyle">
    <div class="hisHeader" ref="hisReport" id="historyReport">
      <Table
        border
        stripe
        size="small"
        :height="tableHeight"
        :columns="columns"
        :data="historyFormData"
        :loading="loading"
        :no-data-text="noDataText"
        border
        ref="historyTable"
      ></Table>
      <Page
        id="page"
        :total="dataCount"
        :page-size="pageSize"
        size="small"
        class="paging"
        @on-change="changepage"
      ></Page>
    </div>
    <div v-if="isEnable" :style="enableStyle"></div>
  </div>
</template>
<style scoped>
.paging {
  float: right;
  margin-top: 5px;
  white-space: nowrap;
  display: flex;
}
/*修改分页背景色*/
#historyReport >>> #page > li {
  background: #f8f8f9;
}
.hisHeader {
  --fontColor: #515a6e;
  --oddColor: #fff;
  --evenColor: #f8f8f9;
  --thColor: #f8f8f9;
  --bgColor: #f8f8f9;
  --borderColor: #000;
  --tableTextColor: #000;
}
#historyReport >>> .ivu-table {
  color: var(--fontColor);
}
#historyReport >>> .ivu-table td {
  background-color: var(--oddColor);
}
#historyReport >>> .ivu-table-stripe .ivu-table-body tr:nth-child(2n) td {
  background-color: var(--evenColor);
}
#historyReport >>> .ivu-table-stripe .ivu-table-fixed-body tr:nth-child(2n) td {
  background-color: var(--evenColor);
}
#historyReport >>> .ivu-table th {
  background-color: var(--thColor);
  /*color: var(--tableTextColor);*/
}
#historyReport >>> .ivu-table {
  background-color: var(--bgColor);
}
#historyReport >>> .ivu-page-next {
  background-color: var(--bgColor);
}
#historyReport >>> .ivu-page-prev {
  background-color: var(--bgColor);
}
#historyReport >>> .ivu-page-item {
  background-color: var(--bgColor);
}
#historyReport >>> .ivu-table:after {
  background-color: transparent;
}
#historyReport >>> .ivu-table:before {
  background-color: transparent;
}
/* 边框为其进行隐藏 */
#historyReport >>> .ivu-table-wrapper {
  /* border:none; */
}
#historyReport >>> .ivu-table th {
  /* border:none; */
}
#historyReport >>> .ivu-table td {
  /* border-color : var(--borderColor); */
}

.ivu-table-wrapper-with-border {
  border: 1px solid #dcdee2 !important;
  border-bottom: 1px solid #dcdee2 !important;
  border-right: 1px solid #dcdee2 !important;
}
</style>
<script>
import Print from "print-js";
import Vue from "vue";
import { locale, Page } from "view-design";
import cn from "view-design/dist/locale/zh-CN";
import en from "view-design/dist/locale/en-US";
Vue.component("Page", Page);
export default {
  name: "",
  props: ["primitives", "fvSystemApi", "parentObject"],
  created() {
    this.changeLange();
    this.defaultTailoring = this.parentObject.defaultTailoring;
    this.windowSize = this.parentObject.windowSize;
    //组件数据混淆
    this.mixin(this.primitives);
    //组件大小位置初始化
    this.domStyle = {
      position: "absolute",
      left: this.x + "px",
      top: this.y + "px",
      width: this.width + "px",
      height: this.height + "px"
    };
    this.enableStyle = {
      position: "absolute",
      width: "100%",
      height: "100%",
      top: "0px",
      backgroundColor: "#ccbfbf",
      opacity: "0.5"
    };
    //字体颜色
    // this.fontColor = "#ccc";
    // //奇数颜色
    // this.oddColor = "#ed4014";
    // //偶数颜色
    // this.evenColor = "#ed4014";
    // //背景颜色
    // this.tableBackgroundColor = "#fff";
    // //是否透明
    // this.isTransparent = false;
    this.modelsPath = this.parentObject.modelsPath.slice(0);
    this.modelsPath.push(this.registerName);
    this.$store.registerModule(this.modelsPath, {
      state: {
        $: this
      }
    });
  },
  mounted() {
    this.func();
  },
  watch: {
    historyFormData: {
      handler(val, oldVal) {
        var n = 0;
        this.isTransparent ? (n = 0.2) : (n = 1);
        this.$refs.hisReport.style.setProperty("--oddColor", this.historyFormData.length != 0 ? this.colorRgba(this.oddColor, n): this.colorRgba("#f8f8f9", n));
        this.$refs.hisReport.style.setProperty("--evenColor", this.historyFormData.length != 0 ? this.colorRgba(this.evenColor, n): this.colorRgba("#f8f8f9", n));
        //字体颜色
        this.$refs.hisReport.style.setProperty("--fontColor", this.fontColor);
        //背景色
      this.$refs.hisReport.style.setProperty("--thColor",this.colorRgba(this.tableBackgroundColor, n));
      //是否开启透明色
      this.$refs.hisReport.style.setProperty("--bgColor",this.isTransparent? "transparent": this.colorRgba(this.tableBackgroundColor, n));
      //目前 文本颜色和边框颜色一致
      this.borderColor = this.fontColor;
      this.$refs.hisReport.style.setProperty("--borderColor", this.borderColor);
      },
      deep: true
    }
  },
  data() {
    return {
      //是否可用
      isEnable: false,
      //是否显示
      isShow: true,
      //组件大小位置,在created(创建完毕，挂载前)函数中初始化
      domStyle: {},
      columns: [],
      historyFormData: [],
      loading: false,
      noDataText: "暂无数据",
      tableHeight: 0,
      pageSize: 5,
      dataCount: 0, // 总条数
      currentPage: 1 // 当前页数
    };
  },
  methods: {
    /*切换语言判断
     */
    changeLange() {
      if (this.$store.state.system.$.languageName == "ch") {
        locale(cn);
      } else {
        locale(en);
      }
    },
    /*
            参数：src 原json数据
            作用：混淆数据到当前对象
        */
    mixin(src) {
      for (var key in src) {
        this[key] = src[key];
      }
    },
    /*
            参数：e 鼠标信息
                 domScale 窗口放大、缩小、偏移等信息
            作用：鼠标事件调用函数，无必要可不进行任何处理
        */
    doFixedEvent(e, domScale) {},
    /*
            参数：无
            作用：系统周期调用
        */
    onTimer() {
      if (this.isEnable) return;
    },
    /*
            参数：无
            作用：所在窗口关闭时调用（vue生命周期函数销毁窗口之前调用）
        */
    onClose() {
      return new Promise(resolve => {
        resolve();
      });
    },
    /*
            参数：scaleObj 重绘信息
            作用：组件需要重绘时触发
        */
    reDraw(scaleObj) {
      this.domStyle.left =
        parseInt(this.x * (scaleObj.sx + scaleObj.zoom) + scaleObj.ox) + "px";
      this.domStyle.top =
        parseInt(this.y * (scaleObj.sy + scaleObj.zoom) + scaleObj.oy) +
        scaleObj.titleHeight +
        "px";
      this.domStyle.width =
        parseInt(this.width * (scaleObj.sx + scaleObj.zoom)) + "px";
      this.domStyle.height =
        parseInt(this.height * (scaleObj.sy + scaleObj.zoom)) + "px";
      this.tableHeight =
        parseInt(this.height * (scaleObj.sy + scaleObj.zoom)) - 29;
      this.getTableData();
      this.isShow = false;
      this.$nextTick(() => {
        this.isShow = true;
        this.changeLange();
      });
    },
    /*
            参数：isShow 显示隐藏
            作用：设置组件整体显隐
        */
    Show(isShow) {
      this.isShow = isShow ? true : false;
    },
    /*
            参数：isEnable 是否可用
            作用：设置组件是否可用
        */
    Enable(isEnable) {
      this.isEnable = isEnable ? false : true;
    },
    /*
            参数：无
            作用：打印表单
        */
    Print() {
      if (this.nav()) {
        this.$Message.warning("只支持PC端进行打印");
      } else {
        this.$Spin.show();
        var columnName = [];
        for (var k in this.historyFormData[0]) {
          columnName.push(k);
        }
        Print({
          printable: this.historyFormData,
          properties: columnName,
          type: "json",
          onLoadingEnd: () => {
            this.$Spin.hide();
          }
        });
      }
    },
    //执行sql语句
    ExecuteSql(data) {
      this.sql = data;
      this.getTableData();
    },
    /*
            参数： 无
            作用： 通过ado名称与Sql语句获得查询数据库返回的数据
        */
    getTableData() {
      if (this.sql.length != 0) {
        // 将用户输入的SQL语句进行转移全小写
        var sql = this.sql.toLowerCase();
        var newStr = sql.substring(0, 6);
        if (newStr == "select") {
          if (sql.indexOf("into") == -1) {
            this.loading = true;
            this.fvSystemApi
              .getDataformRDB(this.dataBaseName, this.sql)
              .then(result => {
                this.updateTable(result.recordset);
              })
              .catch(error => {
                this.loading = false;
                this.noDataText = "数据查询失败";
                console.log(error);
              });
          } else {
            this.alertMsg(0);
          }
        } else {
          this.alertMsg(0);
        }
      } else {
        this.alertMsg(1);
      }
    },
    /*
            参数：data SQL查询回来的数据
            作用：将数据进行对应刷新处理
        */
    updateTable(data) {
      this.noDataText = "查询结果为空";
      if (data.length == 0) return;
      this.temporaryData = data;
      this.updateHeader(data[0]);
      var page = Math.floor((this.tableHeight - 31.89) / 40);
      this.pageSize = page > 1 ? page : 1;
      this.changepage(this.currentPage);
    },
    /*
            参数： name 导出文件的名称
            作用：文件导出
        */
    ExportFile(name) {
      if (name == "") {
        name = "historyReport";
      }
      if (this.temporaryData.length != 0) {
        this.$refs.historyTable.exportCsv({
          filename: name,
          columns: this.columns,
          data: this.temporaryData
        });
      } else {
        this.$Message.error("暂无数据可以进行导出");
      }
    },
    /*
            参数：index 当前页数
            作用：切换分页
        */

    changepage(index) {
      if (this.temporaryData != undefined) {
        this.currentPage = index;
        this.dataCount = this.temporaryData.length;
        var _start = (index - 1) * this.pageSize;
        var _end = index * this.pageSize;
        var data = this.temporaryData.slice(_start, _end);
        this.updateTableData(data);
      }
    },
    /*
            参数：data 查询返回数据的第一条
            作用：将表头展示数据进行渲染
        */
    updateHeader(data) {
      this.columns = [];
      var num = Number(Object.keys(data).length * 80);
      for (var k in data) {
        var obj = {
          title: k,
          key: k,
          align: "center",
          tooltip: true,
          resizable: true,
          width: 180
        };
        this.columns.push(obj);
      }
      if (Object.keys(data).length > 5 && num > this.width) {
        this.columns.forEach(el => {
          el.width = 80;
        });
      }
    },
    /*
            参数：data 查询返回数据
            作用：将表单数据进行渲染
        */
    updateTableData(data) {
      for (var k in data) {
        for (var i in data[k]) {
          //如果是 数字， 就保留两位小数
          if (typeof data[k][i] == Number) {
            data[k][i] = Math.floor(data[k][i] * 100) / 100;
          }
        }
      }

      // 计算字符宽度
      let canvas = document.createElement("canvas");
      canvas.style.positon = "ablsolute";
      let ctx = canvas.getContext("2d");

      // 计算每列最宽的数据长度
      let newData = [...data];
      let jsonData = {};
      newData.map(item => {
        for (const key in item) {
          if (item.hasOwnProperty(key)) {
            if (!jsonData[key]) {
              jsonData[key] = item[key];
            } else {
              if (
                item[key].toString().length > jsonData[key].toString().length
              ) {
                jsonData[key] = item[key];
              }
            }
          }
        }
      });

      let domWidth = parseInt(this.domStyle.width);

      // 计算数据长度值
      let countNum = 0;
      for (const key in jsonData) {
        if (jsonData.hasOwnProperty(key)) {
          // 获取最大值
          let maxWidth = this.getCharSizeByCanvas(
            jsonData[key].toString(),
            canvas,
            ctx
          );
          this.columns.map((item, index) => {
            if (item["key"] == key) {
              // 计算累计值
              countNum += maxWidth + 50;
              // 给表头赋值宽度
              item.width = maxWidth + 50;
            }
          });
        }
      }
      // 如果数据累加的值没有容器本身宽，那么就自适应，如果超过了，那么就按照原来的方式显示
      if (countNum < domWidth) {
        let difference = (domWidth - countNum) / this.columns.length;
        this.columns.map((item, index) => {
          item.width += difference;
        });
      }
      this.historyFormData = data;
      this.loading = false;
    },
    // 计算文字长度
    getCharSizeByCanvas(char, canvas, ctx, style = {}) {
      let { fontSize = 14, fontFamily = "Arial" } = style;
      document.body.appendChild(canvas);
      ctx.font = `${fontSize}px ${fontFamily}`;
      document.body.removeChild(canvas);
      let text = ctx.measureText(char); // TextMetrics object
      ctx.fillText(char, 50, 50);
      return text.width;
    },
    /*
            参数：num 错误类型
            作用：不同错误类型警告框提示内容不同，表单无数据下展示内容也不同
        */
    alertMsg(num) {
      if (num == 0) {
        this.noDataText = "SQL语句只允许为查询语句";
      } else {
        this.noDataText = "请设置SQL语句";
      }
      this.$Notice.error({ title: this.noDataText, duration: 5 });
      this.loading = false;
    },
    /*
            参数：无
            作用：判断是否支持导出的设备
        */

    nav() {
      var ua = navigator.userAgent;
      var ipad = ua.match(/(iPad).*OS\s([\d_]+)/),
        isIphone = !ipad && ua.match(/(iPhone\sOS)\s([\d_]+)/),
        isAndroid = ua.match(/(Android)\s+([\d.]+)/),
        isMobile = isIphone || isAndroid;
      if (isIphone || isAndroid || isMobile) {
        return true;
      } else {
        return false;
      }
    },
    /*
            参数：无
            作用：控制class样式绑定为变量
        */
    func() {
      // 改变表单字体颜色为用户配置
      var n = 0;
      this.isTransparent ? (n = 0.2) : (n = 1);
      //奇数颜色
      this.$refs.hisReport.style.setProperty(
        "--oddColor",this.historyFormData.length != 0? this.colorRgba(this.oddColor, n): this.colorRgba("#f8f8f9", n));
      //字体颜色
      this.$refs.hisReport.style.setProperty("--fontColor", this.fontColor);
      //偶数颜色
      this.$refs.hisReport.style.setProperty("--evenColor",this.historyFormData.length != 0?this.colorRgba(this.evenColor, n):this.colorRgba("#f8f8f9", n));
      //背景色
      this.$refs.hisReport.style.setProperty("--thColor",this.colorRgba(this.tableBackgroundColor, n));
      //是否开启透明色
      this.$refs.hisReport.style.setProperty("--bgColor",this.isTransparent? "transparent": this.colorRgba(this.tableBackgroundColor, n));
      //目前 文本颜色和边框颜色一致
      this.borderColor = this.fontColor;
      this.$refs.hisReport.style.setProperty("--borderColor", this.borderColor);
    },
    /*
            参数：str 十六位制颜色 n 透明度
            作用：将十六位制的颜色转为rgba
        */
    colorRgba(str, n) {
      if (!str) return;
      //十六进制颜色值的正则表达式
      var reg = /^#([0-9a-fA-f]{3}|[0-9a-fA-f]{6})$/;
      var sColor = str.toLowerCase();
      //十六进制颜色转换为RGB格式
      if (sColor && reg.test(sColor)) {
        if (sColor.length === 4) {
          var sColorNew = "#";
          for (var i = 1; i < 4; i += 1) {
            //例如：#eee,#fff等
            sColorNew += sColor.slice(i, i + 1).concat(sColor.slice(i, i + 1));
          }
          sColor = sColorNew;
        }
        //处理六位颜色值
        var sColorChange = [];
        for (var i = 1; i < 7; i += 2) {
          sColorChange.push(parseInt("0x" + sColor.slice(i, i + 2)));
        }
        return "rgba(" + sColorChange.join(",") + "," + n + ")";
      } else {
        return sColor;
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/primitives/fvRelationalLibraryReport/fvRelationalLibraryReport.vue